import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import { useState } from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { ImportConversionTable } from "~/components/specifics/settings/imports/[importType]/import_conversions/ImportConversionTable";
import { importTypeLabels, isImportType } from "~/models/ImportLog";
import { PATH as IMPORTS_PATH } from "~/pages/settings/imports";
import { PATH as IMPORT_PATH } from "~/pages/settings/imports/[importType]";
import SettingStyles from "../../../SettingStyle.module.scss";
import { AddModal } from "./AddModal";

type Props = {
	importType: string;
};

export function Page({ importType }: Props) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	if (!isImportType(importType)) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{
								as: Link,
								href: IMPORTS_PATH,
								label: "過去データ取込"
							},
							{
								as: Link,
								href: IMPORT_PATH(importType),
								label: importTypeLabels[importType]
							},
							{ label: "取込変換設定" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader
						rightArea={
							<Button onClick={handleOpenModal} variant="primary">
								追加
							</Button>
						}
						title={`${importTypeLabels[importType]}の取込変換設定`}
					/>
					<PanelBody>
						<ImportConversionTable importType={importType} />
					</PanelBody>
				</Panel>
				{isModalOpen ? (
					<AddModal handleClose={handleCloseModal} importType={importType} />
				) : null}
			</ClientSettingLayout>
		</DefaultV2>
	);
}
